import { apiProxyRequest } from "Api/apiProxyRequest";

export const updateEmailAddressRequest = (
  userId: string,
  emailAddress: string
) =>
  apiProxyRequest<undefined>(`/users/${userId}/emailaddress`, "POST", {
    email_address: emailAddress
  });
